//is touch device
function isTouchDevice() {
	const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
	document.body.classList.toggle('is-touch', isTouch);
	document.body.classList.toggle('isnt-touch', !isTouch);
}

//is scroll
function isScroll() {
	let position = 0;
	let showFlag = false;
	let vh = window.innerHeight;
	const body = document.body;
	const recalc = () => {
		vh = window.innerHeight;
		position = vh * 3; 
	};
	window.addEventListener('resize', recalc);
	window.addEventListener('load', recalc);
	window.addEventListener('scroll', () => {
		const winTop = window.scrollY;
		if (winTop >= position) {
			if (!showFlag) {
				showFlag = true;
				body.classList.add('is-scroll');
			}
		} else {
			if (showFlag) {
				showFlag = false;
				body.classList.remove('is-scroll');
			}
		}
	}, { passive: true });
	recalc();
}

// navi trigger
function naviTrigger() {
	const body = document.body;
	const triggers = document.querySelectorAll('.site-navi-trigger');
	triggers.forEach(trigger => {
		trigger.addEventListener('click', (e) => {
			const target = e.currentTarget.previousElementSibling;
			body.classList.toggle('is-navi-open');
			const isOpen = body.classList.contains('is-navi-open');
			if (isOpen) {
				gsap.to(target, { scale: 1, duration: 0.3, ease: "power2.out" });
				if (window.lenisInstance) window.lenisInstance.stop();
			} else {
				gsap.to(target, { scale: 0, duration: 0.3, ease: "power2.inOut" });
				if (window.lenisInstance) window.lenisInstance.start();
			}
		});
	});
}

//initirized Lenis
function initLenis() {
	window.lenisInstance = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		smoothWheel: true
	});
	window.lenisInstance.on('scroll', ScrollTrigger.update);
	gsap.ticker.add((time) => {
		window.lenisInstance.raf(time * 1000);
	});
	gsap.ticker.lagSmoothing(0);
}

